export const dances = [
  {
    name: "Tor-Tor",
    description: "Tarian sakral Batak sebagai media komunikasi spiritual, dipentaskan dalam upacara adat, penyembuhan, dan pemanggilan leluhur.",
    movements: "Gerakan tangan naik-turun dan hentakan kaki mengikuti irama gondang; sarana ekspresi doa dan harapan.",
    music: "Gondang Sabangunan atau sambungan gondang tradisional Batak.",
    occasion: "Upacara adat, pemanggilan roh, penyembuhan, serta perayaan seperti pernikahan.",
    meaning: "Simbol spiritual, doa, dan keharmonisan komunitas terhadap leluhur.",
    image: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgvKqiml3fpUwU9TyxydMPXO58KXdCKIrwTthnWuJrfeBnVwsUI-UlzJLUjnJ32xsjyZx_XErmVh1AHu_QeJc_oTNKLAvst-mwSSdVRkXHOG9hYJdCOSlam_ESItCK-Ps0KSvFhT3fu91F7/s640/tari+tor+tor.jpg", // Gambar 1
    references: [
      {
        title: "Tortor – Wikipedia",
        url: "https://en.wikipedia.org/wiki/Tortor"
      },
      {
        title: "Tor-Tor: The Sacred Dance of the Batak People of Indonesia – Indonesia Sentinel",
        url: "https://indonesiasentinel.com/tor-tor-the-sacred-dance-of-the-batak-people-of-indonesia/"
      }
    ],
  },
  {
    name: "Tortor Sipitu Cawan",
    description: "Tarian simbolik dengan tujuh cawan di tubuh penari, digunakan dalam ritual penyucian dan penobatan.",
    movements: "Mengangkat dan menjaga tujuh cawan, menari dengan keseimbangan — simbol perlindungan dan kesakralan.",
    music: "Gondang Sabangunan (musik gondang tradisional Batak).",
    occasion: "Penobatan adat, penyambutan tamu agung, ritual pembersihan.",
    meaning: "Simbol kesucian, keseimbangan kosmik, dan hubungan dengan leluhur.",
    image: "https://th-thumbnailer.cdn-si-edu.com/z_Wtmdj4R0AA7jL788AZbZ5I8aQ=/fit-in/1072x0/https://tf-cmsv2-photocontest-smithsonianmag-prod-approved.s3.amazonaws.com/6131c910e1efe73d281c6cfdef4a1ecf81ceef5d.JPG", // Gambar 2
    references: [
      {
        title: "Jenis-jenis Tari Tor-Tor, termasuk Sipitu Cawan – DetikNews",
        url: "https://news.detik.com/berita/d-5960112/nama-tarian-suku-batak-serba-serbi-tarian-tortor"
      },
      {
        title: "Tortor Sipitu Sawan – Wikipedia Bahasa Indonesia",
        url: "https://id.wikipedia.org/wiki/Tortor_Sipitu_Sawan"
      }
    ],
  },
  {
    name: "Tortor Somba-Somba",
    description: "Tarian penyambutan tamu dengan gerakan penuh hormat, sering dijumpai dalam acara pernikahan adat Batak.",
    movements: "Gerakan tangan lembut dan ritmis, ekspresi penghormatan dan pemberkatan secara halus.",
    music: "Gondang penyambutan, dipadu dengan suara gong lembut.",
    occasion: "Penyambutan tamu penting, upacara pernikahan adat.",
    meaning: "Simbol penghormatan, penerimaan, dan doa pemberkatan.",
    image: "https://cdn.rri.co.id/berita/Jakarta/o/1728449598273-20241009_112536/4i3tvrlq1tqkdju.jpeg", // Gambar 4
    references: [
      {
        title: "Tortor Somba – Contoh pertunjukan di YouTube",
        url: "https://www.youtube.com/watch?v=wO8nufVTwMU"
      },
      {
        title: "Tortor – Wikipedia (penjelasan umum termasuk Somba-somba)",
        url: "https://en.wikipedia.org/wiki/Tortor"
      }
    ],
  },
];
